export default [
    {
      path: '/paiAgent',
      name: '智能体',
      component: () => import(/* webpackChunkName: "paiAgent" */ '@/views/Pai/Agent/experimentalAssistant.vue')
    }
];
  